import React from 'react';
import { Channel } from '../../../../shared/types';
import { useQuery } from '@apollo/react-hooks';
import { GET_PREMIUM_CHANNELS } from '../../../../gql/channels';
import { ChannelsSection } from './ChannelsSection';
import { ChannelsGridProps, prepareChannelsToShow } from './ChannelsGridUtils';

export const PremiumChannels = (props: ChannelsGridProps) => {
    const { randomize = false, quantityToDisplay } = props;
    const { loading, data } = useQuery(GET_PREMIUM_CHANNELS, {
        fetchPolicy: 'network-only',
    });
    const premiumChannels = prepareChannelsToShow(
        data?.premiumChannels,
        randomize,
        quantityToDisplay
    ) as Channel[];

    return (
        <ChannelsSection
            title="Premium channels"
            channels={premiumChannels}
            loading={loading}
            type="premium"
        />
    );
};
